// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M12 0.856079L22 6.41163V9.00004H2V6.41163L12 0.856079ZM2 21H22V23H2V21Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7 19H5V11H7V19Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M13 19H11V11H13V19Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M19 19H17V11H19V19Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-institution-filled')
export default class InstitutionFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'institution-filled',
    }
  }
}
